import { render, staticRenderFns } from "./shop-item-status.vue?vue&type=template&id=092b2c41&scoped=true&"
import script from "./shop-item-status.vue?vue&type=script&lang=js&"
export * from "./shop-item-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b2c41",
  null
  
)

export default component.exports